<script>
import { usePreferences } from '@/platform/composables/usePreferences';

export default {
  setup() {
    const { shouldMinimizeSidebar } = usePreferences();

    return {
      shouldMinimizeSidebar,
    };
  },
  data() {
    return {
      stylesMinimize: {
        width: '40px',
      },
      stylesFull: {
        width: '164px',
      },
    };
  },
};
</script>

<template>
  <span class="mx-auto" :style="shouldMinimizeSidebar ? stylesMinimize : stylesFull">
    <slot />
  </span>
</template>
